import { MinRelationships, OtherRelationships } from 'app/Bookings/constants'

export enum SalesforceLeadRelationship {
  MYSELF = 'Myself',
  SPOUSE = 'Spouse',
  CHILD = 'Child',
  GRANDFATHER_OR_GRANDMOTHER = 'Grandfather or Grandmother',
  GRANDSON_OR_GRANDDAUGHTER = 'Grandson or Granddaughter',
  STEPSON_OR_STEPDAUGHTER = 'Stepson or Stepdaughter',
  SIGNIFICANT_OTHER = 'Significant Other',
  MOTHER = 'Mother',
  FATHER = 'Father',
  OTHER_ADULT = 'Other Adult',
  LIFE_PARTNER = 'Life Partner',
  OTHER_RELATIONSHIP = 'Other Relationship',
}

export enum AutofillForm {
  EMAIL = 'email',
  RP_FORM = 'rp_form',
  PATIENT_INFO = 'patient_info',
  INSURANCE = 'insurance',
}

export const sfToTWRelationship = {
  [SalesforceLeadRelationship.MYSELF]: MinRelationships.SELF,
  [SalesforceLeadRelationship.SPOUSE]: MinRelationships.SPOUSE,
  [SalesforceLeadRelationship.CHILD]: MinRelationships.CHILD,
  [SalesforceLeadRelationship.GRANDFATHER_OR_GRANDMOTHER]:
    OtherRelationships.Grandparent,
  [SalesforceLeadRelationship.GRANDSON_OR_GRANDDAUGHTER]:
    OtherRelationships.Grandchild,
  [SalesforceLeadRelationship.STEPSON_OR_STEPDAUGHTER]:
    OtherRelationships.Stepchild,
  [SalesforceLeadRelationship.SIGNIFICANT_OTHER]:
    OtherRelationships.SignificantOther,
  [SalesforceLeadRelationship.MOTHER]: OtherRelationships.Mother,
  [SalesforceLeadRelationship.FATHER]: OtherRelationships.Father,
  [SalesforceLeadRelationship.OTHER_ADULT]: OtherRelationships.OtherAdult,
  [SalesforceLeadRelationship.LIFE_PARTNER]: OtherRelationships.LifePartner,
  [SalesforceLeadRelationship.OTHER_RELATIONSHIP]:
    OtherRelationships.OtherRelationship,
}

export type SalesforceObjectType = 'account' | 'case' | 'lead'

export const VALID_SF_OBJECT_TYPES: Set<SalesforceObjectType> = new Set<SalesforceObjectType>(
  ['account', 'case', 'lead']
)

export function isValidSfObjectType(
  sfObjectType: SalesforceObjectType
): boolean {
  return VALID_SF_OBJECT_TYPES.has(sfObjectType)
}
